import React from "react";
import PermitApprovers from "../PermitApprovers";
import { permitToWorkSupportingDocuments, WorkPermitApprover } from "../../../constants/common";
import PermitDetails from "./PermitDetails";
import ScopeOfWork from "./ScopeOfWork";
import PermitRequirements from "../PermitRequirements";
import SupportingDocuments from "../SupportingDocuments";
import Wrapper from "../Wrapper";

interface PermitToWorkPDFProps {
  permitDetails: {
    s_WorkCategory_En: string;
    s_WorkType_En: string;
    s_HighRiskWorkCategory_En: string;
    dt_PermitStartDate: any;
    dt_PermitEndDate: any;
    s_AffectedService_En: string;
    s_FloorNo: string;
    s_OfficeNo: string;

    buildings: {
      s_LocationName_En: string;
      s_LocationName_Ar: string;
      items: {
        s_BuildingName_En: string;
        s_BuildingName_Ar: string;
      }[];
    }[];

    s_ScopeOfWork: string;

    safetyChecklist: {
      titleEn: string;
      titleAr: string;
      items: {
        id: string;
        titleEn: string;
        titleAr: string;
        checked: boolean;
      }[];
    }[];

    haveWorkPlanFile: boolean;
    haveMethodStatementFile: boolean;
    haveRiskAssessmentFile: boolean;

    approvers: WorkPermitApprover[];
  };
}

const PermitToWorkPDF: React.FC<PermitToWorkPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="Permit To Work">
      <PermitDetails permitDetails={permitDetails} />
      <ScopeOfWork scopeOfWork={permitDetails.s_ScopeOfWork} />
      <PermitRequirements sectionNumber={3} safetyChecklist={permitDetails.safetyChecklist} />
      <SupportingDocuments sectionNumber={4} permitDetails={permitDetails} documents={permitToWorkSupportingDocuments} />
      <PermitApprovers sectionNumber={5} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default PermitToWorkPDF;
